import { Injectable } from '@angular/core';
import { BaseApi } from './_base-api';
import { CategoriesOnHome, CategoryCreate, CategoryEntity, CategoryUpdate } from '@repo/types';

@Injectable({
  providedIn: 'root',
})
export class CategoryApiService extends BaseApi<CategoryEntity, CategoryCreate, CategoryUpdate> {
  constructor() {
    super('Categories', {
      get: '/AdminPanel/GetCategories',
      post: '/AdminPanel/AddCategory',
    });
  }

  updateCategory(model: CategoryUpdate) {
    return http$.patch<never>('/AdminPanel/EditCategory', model);
  }

  deleteCategory(id: number) {
    return http$.delete<never>('/AdminPanel/DeleteCategory', { body: { id: id } });
  }

  getCategoriesOnHome() {
    return http$.get<CategoriesOnHome>('/AdminPanel/GetCategoriesOnHome');
  }

  editCategoriesOnHome(model: { categoryIds: number[] }) {
    return http$.patch<never>('/AdminPanel/EditCategoriesOnHome', model);
  }
}
